module.exports = __webpack_public_path__ + "img/MM_Tax_Service_logo.5f248927.png";